import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acf2dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant table-hover" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID", -1))
const _hoisted_7 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_8 = { colspan: "12" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "dialog-footer" }

import { ref, onMounted, nextTick } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import PaymentService from "../services/PaymentService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import CryptoTransaction from "../components/crypto/CryptoTransaction.vue";
import UnifiedTwoFaVerificationModal from "@/components/modal/UnifiedTwoFaVerificationModal.vue";
import { AuthEventTypes } from "@/core/types/AuthEventTypes";
import {
  CryptoStatusTypeOptions,
  CryptoStatusTypes,
} from "@/core/types/crypto/CryptoStatus";
import notification from "@/core/plugins/notification";
import MsgPrompt from "@/core/plugins/MsgPrompt";

type VerificationMethod = "email" | "sms" | "authenticator";


export default /*#__PURE__*/_defineComponent({
  __name: 'CryptoIndex',
  setup(__props) {

const isLoading = ref(false);
const isRefreshing = ref(false);
const isSubmitting = ref(false);
const cryptoTransactionRef = ref<any>(null);
const accountSelected = ref(0);
const expireTime = ref(0);
const expireData = ref<any>([]);
const data = ref(<any>[]);
const showAddModal = ref(false);
const twoFaModalRef = ref<any>(null);
const pendingTwoFaCode = ref("");
const pendingAuthMethod = ref<VerificationMethod | null>(null);
const pendingToggleItem = ref<any>(null);
const pendingTogglePrevStatus = ref<number | null>(null);
const pendingToggleNextStatus = ref<number | null>(null);
const pendingAction = ref<"addCrypto" | "toggleStatus" | null>(null);
const store = useStore();
const router = useRouter();
const { t } = useI18n();
const user = store.state.AuthModule.user;
const newCrypto = ref({
  name: "",
  type: "",
  address: "",
});
const availableTypes = ref<string[]>([]);
const criteria = ref<any>({
  page: 1,
  size: 30,
  showInactive: false,
  category: "Crypto",
  // when showInactive is false we hide inactive by passing status [0,1]
  // (show statuses 0 and 1, hide 2)
  status: [0, 1],
});

const hasValidAuthTypes = (authTypes: any) =>
  Array.isArray(authTypes) && authTypes.filter(Boolean).length > 0;

const showTwoFaRequiredNotice = () => {
  showAddModal.value = false;
  MsgPrompt.warning(
    t("tip.twoFaRequiredForAction"),
    "",
    t("action.setUpNow")
  ).then((result: any) => {
    if (result?.isConfirmed) {
      router.push({ name: "profileSetting" });
    }
  });
};

const updateStatus = async (item: any, nextStatus: number) => {
  if (isRefreshing.value || isLoading.value) {
    return;
  }
  isSubmitting.value = true;
  try {
    const params: any = {};

    if (pendingTwoFaCode.value && pendingAuthMethod.value) {
      params.code = pendingTwoFaCode.value;
      params.authType = pendingAuthMethod.value;
    }

    const response = await PaymentService.updateCryptoWalletStatus(
      item.id,
      nextStatus,
      params
    );

    if (
      response?.twoFactorRequired &&
      !hasValidAuthTypes(response?.authTypes)
    ) {
      showTwoFaRequiredNotice();
      return;
    }

    if (response?.twoFactorRequired && response?.authTypes) {
      pendingToggleItem.value = item;
      pendingTogglePrevStatus.value = item.status;
      pendingToggleNextStatus.value = nextStatus;
      pendingAction.value = "toggleStatus";
      twoFaModalRef.value?.show(
        response.authTypes,
        user.email,
        response.authTypes,
        undefined,
        AuthEventTypes.UpdateTenantCryptoWalletStatus
      );
      return;
    }

    if (twoFaModalRef.value) {
      twoFaModalRef.value.closeModal();
    }
    pendingTwoFaCode.value = "";
    pendingAuthMethod.value = null;
    pendingAction.value = null;
    item.status = nextStatus;
    pendingToggleItem.value = null;
    pendingTogglePrevStatus.value = null;
    pendingToggleNextStatus.value = null;
    notification.success();
  } catch (error) {
    if (
      pendingTwoFaCode.value &&
      pendingAuthMethod.value &&
      twoFaModalRef.value &&
      pendingAction.value === "toggleStatus"
    ) {
      let msg = t("tip.invalidCodePleaseTryAgain");
      const serverMsg = error?.response?.data?.message as string | undefined;
      if (
        serverMsg &&
        !serverMsg.toLowerCase().includes("invalid authentication code")
      ) {
        msg = serverMsg;
      }
      twoFaModalRef.value.showError(msg);
      pendingTwoFaCode.value = "";
      pendingAuthMethod.value = null;
      pendingAction.value = null;
      return;
    }
    console.log(error);
    notification.danger();
  } finally {
    isSubmitting.value = false;
  }
};

const onToggleStatus = async (item: any, nextStatus: number) => {
  if (item.status === nextStatus) {
    return;
  }
  await updateStatus(item, nextStatus);
};

const fecthExpireTime = async () => {
  try {
    const res = await PaymentService.queryCryptoExpireTime(
      "public",
      0,
      "CryptoSetting"
    );
    expireTime.value = res.value["payExpiredTimeInMinutes"];
    expireData.value = res;
  } catch (error) {
    console.log(error);
  }
};

const updateExpireTime = async () => {
  isSubmitting.value = true;
  try {
    await PaymentService.updateCryptoExpireTime("public", 0, "CryptoSetting", {
      key: expireData.value.key,
      name: expireData.value.name,
      dataFormat: expireData.value.dataFormat,
      value: { payExpiredTimeInMinutes: expireTime.value },
    });
    notification.success();
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  isSubmitting.value = false;
};

const fecthData = async () => {
  isLoading.value = true;
  isRefreshing.value = true;
  try {
    // ensure category is set and status follows showInactive
    criteria.value.category = "Crypto";
    // when showInactive is false (we hide inactive) request statuses 0 and 1
    // when showInactive is true (we show inactive) request statuses 0, 1, 2
    criteria.value.status = criteria.value.showInactive ? [0, 1, 2] : [0, 1];

    const res = await PaymentService.queryCryptoWallets(criteria.value);
    // API may return { data: [...] } or an array directly
    const items = Array.isArray(res) ? res : res.data ?? [];
    data.value = items;

    // Extract unique types for the dropdown
    const types = new Set<string>();
    items.forEach((item: any) => {
      if (item.type) {
        types.add(item.type);
      }
    });
    availableTypes.value = Array.from(types);
    if (!availableTypes.value.includes("USDTTRC20")) {
      availableTypes.value.push("USDTTRC20");
    }
  } catch (error) {
    console.log(error);
  } finally {
    await nextTick();
    isRefreshing.value = false;
    isLoading.value = false;
  }
};

const onShowInactiveChange = () => {
  fecthData();
};

const showAddCryptoModal = () => {
  newCrypto.value = {
    name: "",
    type: "",
    address: "",
  };
  pendingAction.value = "addCrypto";
  showAddModal.value = true;
};

const handleAddCrypto = async () => {
  if (
    !newCrypto.value.name ||
    !newCrypto.value.type ||
    !newCrypto.value.address
  ) {
    MsgPrompt.error("Please fill in all fields");
    return;
  }

  isSubmitting.value = true;
  try {
    const payload: any = {
      name: newCrypto.value.name,
      type: newCrypto.value.type,
      address: newCrypto.value.address,
    };

    if (pendingTwoFaCode.value && pendingAuthMethod.value) {
      payload.code = pendingTwoFaCode.value;
      payload.authType = pendingAuthMethod.value;
    }

    const response = await PaymentService.addCryptoWallet(payload);

    if (
      response?.twoFactorRequired &&
      !hasValidAuthTypes(response?.authTypes)
    ) {
      showTwoFaRequiredNotice();
      return;
    }

    if (response?.twoFactorRequired && response?.authTypes) {
      pendingAction.value = "addCrypto";
      twoFaModalRef.value?.show(
        response.authTypes,
        user.email,
        response.authTypes,
        undefined,
        AuthEventTypes.CreateTenantCryptoWallet
      );
      return;
    }

    if (twoFaModalRef.value) {
      twoFaModalRef.value.closeModal();
    }
    pendingTwoFaCode.value = "";
    pendingAuthMethod.value = null;
    pendingAction.value = null;
    notification.success();
    showAddModal.value = false;
    await fecthData();
  } catch (error) {
    if (
      pendingTwoFaCode.value &&
      pendingAuthMethod.value &&
      twoFaModalRef.value
    ) {
      let msg = t("tip.invalidCodePleaseTryAgain");
      const serverMsg = error?.response?.data?.message as string | undefined;
      if (
        serverMsg &&
        !serverMsg.toLowerCase().includes("invalid authentication code")
      ) {
        msg = serverMsg;
      }
      twoFaModalRef.value.showError(msg);
      pendingTwoFaCode.value = "";
      pendingAuthMethod.value = null;
      pendingAction.value = null;
      return;
    }
    console.log(error);
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const onTwoFaVerified = async (code: string, method: VerificationMethod) => {
  pendingTwoFaCode.value = code;
  pendingAuthMethod.value = method;
  if (
    pendingAction.value === "toggleStatus" &&
    pendingToggleItem.value &&
    pendingToggleNextStatus.value !== null
  ) {
    await updateStatus(pendingToggleItem.value, pendingToggleNextStatus.value);
    return;
  }
  await handleAddCrypto();
};

const onTwoFaCancel = () => {
  pendingTwoFaCode.value = "";
  pendingAuthMethod.value = null;
  pendingAction.value = null;
  if (pendingToggleItem.value && pendingTogglePrevStatus.value !== null) {
    pendingToggleItem.value.status = pendingTogglePrevStatus.value;
  }
  pendingToggleItem.value = null;
  pendingTogglePrevStatus.value = null;
  pendingToggleNextStatus.value = null;
};

const cancelAddCrypto = () => {
  showAddModal.value = false;
  pendingAction.value = null;
};

const getStatusLabel = (value: number) => {
  const option = CryptoStatusTypeOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

function getStatusTag(status: CryptoStatusTypes) {
  switch (status) {
    case CryptoStatusTypes.Idle:
      return "success";
    case CryptoStatusTypes.InUse:
      return "warning";
    case CryptoStatusTypes.Inactive:
      return "danger";
  }
}

const view = (item: any) => {
  cryptoTransactionRef.value.show(item);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

onMounted(() => {
  fecthData();
  fecthExpireTime();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("tip.paymentExpireTime")), 1),
          _createVNode(_component_el_input, {
            type: "number",
            modelValue: expireTime.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((expireTime).value = $event)),
            style: {"width":"75px"},
            class: "mx-4"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: updateExpireTime,
            disabled: isSubmitting.value,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: showAddCryptoModal,
            disabled: isSubmitting.value,
            plain: "",
            class: "ms-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Add Crypto Wallet ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_switch, {
            modelValue: criteria.value.showInactive,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.showInactive) = $event)),
            "active-text": _ctx.$t('action.showInactive'),
            "inactive-text": _ctx.$t('action.hideInactive'),
            disabled: isLoading.value,
            onChange: onShowInactiveChange,
            class: "ms-4"
          }, null, 8, ["modelValue", "active-text", "inactive-text", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.onOff")), 1),
              _hoisted_6,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.walletAddress")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
              'row-inactive': item.status === _unref(CryptoStatusTypes).Inactive,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        (item.status != _unref(CryptoStatusTypes).InUse)
                          ? (_openBlock(), _createBlock(_component_el_switch, {
                              key: 0,
                              "model-value": item.status,
                              size: "large",
                              style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"},
                              "inline-prompt": "",
                              "active-value": _unref(CryptoStatusTypes).Idle,
                              "inactive-value": _unref(CryptoStatusTypes).Inactive,
                              "active-text": "ON",
                              "inactive-text": "OFF",
                              onChange: ($event: any) => (onToggleStatus(item, $event)),
                              loading: isSubmitting.value
                            }, null, 8, ["model-value", "active-value", "inactive-value", "onChange", "loading"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.type), 1),
                      _createElementVNode("td", null, _toDisplayString(item.address), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          size: "large",
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.balance ?? item.balanceInCents ?? "-"), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn,
                          type: "GMToneLiner"
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (view(item)),
                          plain: "",
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ], 10, _hoisted_11))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(CryptoTransaction, {
      ref_key: "cryptoTransactionRef",
      ref: cryptoTransactionRef
    }, null, 512),
    _createVNode(UnifiedTwoFaVerificationModal, {
      ref_key: "twoFaModalRef",
      ref: twoFaModalRef,
      onVerified: onTwoFaVerified,
      onCancel: onTwoFaCancel
    }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: showAddModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showAddModal).value = $event)),
      title: "Add Crypto Wallet",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, { onClick: cancelAddCrypto }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleAddCrypto,
            disabled: isSubmitting.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Submit ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: newCrypto.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Name" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCrypto.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newCrypto.value.name) = $event)),
                  placeholder: "Enter name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Type" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: newCrypto.value.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newCrypto.value.type) = $event)),
                  placeholder: "Select type",
                  style: {"width":"100%"},
                  "allow-create": "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTypes.value, (type) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: type,
                        label: type,
                        value: type
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Wallet Address" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newCrypto.value.address,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newCrypto.value.address) = $event)),
                  placeholder: "Enter wallet address"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})